// Minimal `process` for packages that read process.env in the browser.
module.exports = {
  env: {},
  platform: 'browser',
  browser: true,
  nextTick: fn => Promise.resolve().then(fn),
};
